import api from "./api";

/* =========================================
   CREATE (with PDFs)
========================================= */
export const createBatch = (formData) => {
  return api.post("/api/batch-records/full", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/* =========================================
   UPDATE (fields + PDFs)
========================================= */
export const updateBatch = (id, formData) => {
  return api.put(`/api/batch-records/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/* =========================================
   GET ALL
========================================= */
export const getAllBatches = () => {
  return api.get("/api/batch-records");
};

/* =========================================
   GET ONE
========================================= */
export const getBatchById = (id) => {
  return api.get(`/api/batch-records/${id}`);
};

/* =========================================
   DELETE (soft delete)
========================================= */
export const deleteBatch = (id) => {
  return api.delete(`/api/batch-records/${id}`);
};
